import { useFetchPermissions } from "../../services/admin-settings/admin-settings";

// HR admin and manager permission, beware of drift due to lack of constant
// TODO: extract HR admin permission constant
const HR_QUALIFYING_PERMISSION = "view-ui:menu.team";

/**
 * Whether the current user should receive Userpilot in-app messages based on their HR role
 * (HR Admin or Manager). See useCanReceiveUserpilotAsAts for the ATS-side equivalent.
 *
 * This uses useFetchPermissions from admin-settings.ts because those permission fetches
 * actually return all permissions with nothing specific to admin settings.
 *
 * No loading state is exposed here: hasPermission() can only return true once the underlying
 * query has data, which is already mutually exclusive with that query still loading — so there
 * is no window where this could resolve true before permissions have actually loaded.
 */
export function useCanReceiveUserpilotAsHr(): boolean {
  const { hasPermission } = useFetchPermissions("hr");

  return hasPermission(HR_QUALIFYING_PERMISSION);
}
